import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import InfrastructuresDt from '@/services/dataTransferModules/infrastructuresDt'

export default function useInfrastructure(params = {
	useLocalRefs: true,
	showErrorNotificationForLoadingAllEntities: true,
}) {
	const { t: $t } = useI18n()

	const infrastructuresDt = new InfrastructuresDt()

	const {
		loadEntityFlags: flags,

		entities: fullInfrastructure,
		getEntities: getInfrastructures,

		extendedEntities: extendedInfrastructure,
		getExtendedEntities: getExtendedInfrastructures,

		basedEntities: baseInfrastructure,
		getBasedEntities: getBasedInfrastructures,

		hashedBasedEntities: hashedBasedInfrastructure,
		getHashedBasedEntities: getHashedBasedInfrastructure,

		createEntity: createInfrastructures,

		entity: infrastructure,
		getEntity: getInfrastructure,

		entityPopup: infrastructuresPopup,
		getEntityPopup: getInfrastructurePopup,

		entityPreview: infrastructuresPreview,
		getEntityPreview: getInfrastructurePreview,

		patchEntity: updateInfrastructure,

		deleteEntity: deleteInfrastructure,
	} = useBlProviders(infrastructuresDt, Object.assign({
		getAllMethodName: 'getFilteredInfrastructures',

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading infrastructure object'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Couldn`t add a new infrastructure. Please contact technical support team.'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Failed to load data. Contact technical support team.'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Couldn`t edit a infrastructure. Please contact technical support team.'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Couldn`t remove. Please contact technical support team.'),
	}, params))

	return {
		flags,
		fullInfrastructure,
		baseInfrastructure,
		extendedInfrastructure,
		infrastructuresPopup,
		infrastructuresPreview,
		infrastructure,

		getBasedInfrastructures,
		getExtendedInfrastructures,
		getInfrastructures,
		getInfrastructurePreview,
		getInfrastructurePopup,
		getInfrastructure,
		createInfrastructures,
		deleteInfrastructure,
		updateInfrastructure,

		hashedBasedInfrastructure,
		getHashedBasedInfrastructure,
	}
}
